/**
 * Query para obtener Orden de Compra por ID (búsqueda más rápida)
 * Usado para obtener datos descriptivos actuales de la OC.
 */
export const GET_ORDEN_COMPRA = `
  query GetOrdenCompra($id: String!) {
    getOrdenCompra(id: $id) {
      id
      createdAt
      updatedAt
      fechaRegistro
      tipoOC
      tipoEgreso
      categoriaEgreso
      numeroOC
      fechaPago
      moneda
      montoPagar
      observaciones
      estado
    }
  }
`;

export const buildGetAllOrdenCompraAvailableQuery = (fields: string): string => `
  query getAllOrdenCompraAvailable($projectionExpression: String) {
    getAllOrdenCompraAvailable(projectionExpression: $projectionExpression) {
${fields}
    }
  }
`;

export const buildGetOrdenCompraAvailablePageQuery = (fields: string): string => `
  query getOrdenCompraAvailablePage(
    $projectionExpression: String
    $limit: Float
    $nextToken: String
  ) {
    getOrdenCompraAvailablePage(
      projectionExpression: $projectionExpression
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
${fields}
      }
      nextToken
      hasMore
    }
  }
`;

export const DELETE_ORDEN_COMPRA = `
  mutation deleteOrdenCompra($id: String!) {
    deleteOrdenCompra(id: $id)
  }
`;

export const VALIDAR_VINCULO_BY_ORDEN_COMPRA_ID = `
  query validarVinculoByOrdenCompraId($idVinculado: String!) {
    validarVinculoByOrdenCompraId(idVinculado: $idVinculado) {
      vinculado
      idVinculado
    }
  }
`;

/**
 * Mutation para eliminar Órdenes de Compra de un Registro de Compra por IDs de vínculos
 */
export const DELETE_ORDEN_COMPRA_DE_RC_BY_ID_VINCULO = `
  mutation DeleteOrdenCompraDeRegistroCompraByIdVinculoUseCase($IdVinculos: [String!]!) {
    DeleteOrdenCompraDeRegistroCompraByIdVinculoUseCase(IdVinculos: $IdVinculos)
  }
`;
